import { Component, HostListener, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonApp,
  IonMenu, IonHeader, IonContent, IonToolbar, IonTitle,
  IonButtons, IonMenuButton, IonList, IonItem, IonLabel, IonItemDivider,
  MenuController
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';

import { RouterLink, RouterOutlet, Router, RouterLinkActive } from '@angular/router';
import { UserDropdownComponent } from 'src/app/shared/components/header/user-dropdown/user-dropdown.component';
import { DashboardStateService } from 'src/app/core/services/dashboard-state.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { MenuType } from 'src/app/core/interfaces/menu.interface';


@Component({
  selector: 'app-app-dashboard',
  templateUrl: './app-dashboard.component.html',
  styleUrls: ['./app-dashboard.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    UserDropdownComponent,
    IonApp,
    IonMenu,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonMenuButton,
    IonList,
    IonItem,
    IonLabel,
    IonItemDivider
  ],
})
export class AppDashboardComponent implements OnInit {
  private subscription!: Subscription;
  router = inject(Router);
  dashboardState = inject(DashboardStateService);
  private authService = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private menuCtrl = inject(MenuController);
  isDesktop = false;
  menuData: any = null;
  envName = environment.envName;

  eventData: any = null;

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  canAccessEventoConfiguracionesAvanzadas(): boolean {
    return this.authService.canAccessEventoConfiguracionesAvanzadas();
  }

  canAccessEventoDashboard(): boolean {
    return this.authService.canAccessEventoDashboard();
  }

  canAccessEventoInfoBasica(): boolean {
    return this.authService.canAccessEventoInfoBasica();
  }

  canGestionarEvento(): boolean {
    return this.authService.canGestionarEvento();
  }

  canViewReportes(): boolean {
    return this.authService.canViewReportes();
  }

  canViewVentas(): boolean {
    return this.authService.canViewVentas();
  }

  canViewHistorialCarritos(): boolean {
    return this.authService.canViewHistorialCarritos();
  }

  canViewFunciones(): boolean {
    return this.authService.canViewFunciones();
  }

  ngOnInit() {
    this.checkScreenSize();
    
    // Suscribirse a los cambios del menú (BehaviorSubject emite valor inicial inmediatamente)
    this.subscription = this.dashboardState.menuData$.subscribe(data => {
      this.menuData = data;
      if(this.menuData && this.menuData.typeMenu == MenuType.EVENTOS){
        this.eventData = this.menuData.currentData;
        console.log('Evento actual:', this.eventData);
      }
      console.log('Datos del menú recibidos en el componente:', data);
      console.log('Menú actualizado:', data);
      this.cdr.detectChanges();
    });
  }



  constructor() {
    
  }

  isActive(url: string): boolean {
    return window.location.pathname === url;
  }
  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth >= 992;
  }
  goHome() {
    this.router.navigate(['/']);
  }

  goTo(...paths: any[]) {
    this.router.navigate(paths);
    this.closeMenu();
  }

  async closeMenu() {
    await this.menuCtrl.close('mobile-menu');
  }
}
